import get from "lodash/get";
import _ from "lodash";
import { action, makeObservable } from "mobx";
import { observer } from "mobx-react";
import React, { Component } from "react";
import { NavLink, Route, Switch, withRouter } from "react-router-dom";

import config from "../../config";
import Icon from "../Icon";
import { popupAbout } from "../../Widgets/About/About";
import { openShareLinkModal } from "../../Widgets/ShareLink/ShareLinkModal";
import { findRouteByWebRegExp } from "../../Widgets/ShareLink/ShareLinkUtils";
import className from "../className";
import "./Header.scss";
import collapse from "./images/collapse.svg";
import expand from "./images/expand.svg";
import menu from "./images/menu.svg";
import mainNavConfig from "./mainNavConfig";
import patientNavigationPath from "../patientNavigationPath";
import DilatationMeter from "../../Widgets/ObSurveil/ObSurveilPatient/DilatationMeter";
import { withStore, StoreContext } from "../../AppStore";
import { popupPrefs } from "../../Widgets/Preferences";
import { roleOptions } from "../../Widgets/Preferences/PreferencesViewModel";
import { popupSwitchSite } from "../../Widgets/SwitchSite/SwitchSite";

class HeaderWithoutRouter extends Component {
  static contextType = StoreContext;
  constructor(props) {
    super(props);

    makeObservable(this, {
      logout: action,
      toggleUserMenu: action,
      closeUserMenu: action,
    });

    this.logout = this.logout.bind(this);
    this.toggleUserMenu = this.toggleUserMenu.bind(this);
    this.closeUserMenu = this.closeUserMenu.bind(this);
    this.backToPatientList = this.backToPatientList.bind(this);
    this.toggleMenus = this.toggleMenus.bind(this);
    this.popupAbout = popupAbout.bind(this);
    this.share = this.share.bind(this);
    this.navLinkClick = navLinkClick.bind(this);
    this.openPrefs = popupPrefs.bind(this);
    this.openSwitchSite = popupSwitchSite.bind(this);
  }

  render() {
    let active = "";
    const patient = get(this, "props.store.patient");
    const configMainNav = [...(config.mainNav || [])];

    if (get(this.props.store, "patientTilesStore.tiles.documents")) {
      if (!configMainNav.includes("documents")) {
        configMainNav.push("documents");
      }
    }

    this.navItems = config.mainNav
      ? mainNavConfig
          .map((item) => (configMainNav.includes(item.route) ? item : false))
          .filter((item) => item)
      : mainNavConfig;

    const { pathname } = this.props.location;
    let isObRoute =
      pathname.includes("ob-surveil") || pathname.includes("ob-summary");

    let sites;
    if (sessionStorage.sites) {
      sites = JSON.parse(sessionStorage.sites);
    }

    let height;
    if (this.props.store?.menuOpen) height = this.refHeader?.scrollHeight;

    return (
      <header
        {...className({
          "main-header": true,
          open: this.props.store?.menuOpen,
          "patient-routed": this.isPatientRoute,
          "collapse-main-nav": config.hideAppHeader,
          "main-nav-hidden": this.props.store?.hideMainNav,
        })}
        ref={(ref) => (this.refHeader = ref)}
        style={{ height }}
      >
        {config.hideAppHeader ? null : (
          <div className="header-top">
            <a href="/" className="home-link" onClick={this.backToPatientList}>
              <div className="grid-btn"></div>
              {config.logo ? (
                <img src={config.logo} alt="AirstripONE®" className="logo" />
              ) : null}
              {config.siteName}
            </a>
            <div className="header-top-menu-buttons">
              {config.enableSecureMessaging && this.props.store?.messaging ? (
                <div className="messages-button-wrapper">
                  <div
                    className="messages-button"
                    onClick={
                      this.props.store.messagingStore.toggleShowMessaging
                    }
                  >
                    <Icon symbol="messages" />
                    {this.props.store?.messagingStore.numNewMessages > 0 && (
                      <div className="message-count-badge">
                        {this.props.store?.messagingStore.numNewMessages}
                      </div>
                    )}
                  </div>
                </div>
              ) : null}
              <div className="user-menu-button" onClick={this.toggleUserMenu}>
                {this.displayName} <Icon symbol="dropdown" />
              </div>
              {config.collapseMainNav ? null : (
                <img
                  className="icon-menu"
                  src={this.props.store?.menuOpen ? collapse : expand}
                  alt="menu"
                  onClick={this.toggleMenus}
                />
              )}
            </div>
          </div>
        )}

        {config.hideAppHeader ? null : (
          <div
            className={`user-menu ${this.context.userMenuOpen ? "open" : ""}`}
          >
            <NavLink to="#" className="about" onClick={this.popupAbout}>
              About
            </NavLink>
            <button type="button" className="prefs" onClick={this.openPrefs}>
              Preferences
            </button>
            {config.ENABLE_SITE_SWITCHER && sites && (
              <button
                type="button"
                className="prefs"
                onClick={this.openSwitchSite}
              >
                Switch Site
              </button>
            )}
            <button type="button" className="logout" onClick={this.logout}>
              Logout
            </button>
          </div>
        )}
        {patient && this.isPatientRoute ? (
          <div className="patient-header">
            {!config.collapseMainNav && config.hideAppHeader ? (
              <img
                className="icon-menu"
                src={menu}
                alt="menu"
                onClick={this.toggleMenus}
              />
            ) : null}
            {config.enableSecureMessaging && this.isSharable ? (
              <a href="share" className="share" onClick={this.share}>
                Share
              </a>
            ) : null}
            {(this.props.store.showPatientHeader ??
              !config.hidePatientInfoHeader) && (
              <div className="patient-info">
                {config.hideAppHeader || this.isCreateStatement ? null : (
                  <div className="back" onClick={this.backToPatientList}></div>
                )}
                {isObRoute && (
                  <DilatationMeter
                    dilatation={get(
                      patient.moduleSpecificData.find((d) => d.dilatation),
                      "dilatation",
                    )}
                  />
                )}
                <div className="info-container">
                  <div className="name">
                    {config.hidePHI
                      ? `${patient.lastName[0]}, ${patient.firstName[0]}`
                      : `${patient.lastName}, ${patient.firstName}`}
                    {isObRoute ? (
                      <span className="age"> {patient.age}</span>
                    ) : (
                      <span className="age">
                        {` ${get(patient, "gender[0]", "U")} • `}
                        {patient.age}
                      </span>
                    )}
                  </div>
                  <div className="info">
                    {this.patientSubheadInfo.join(" • ")}
                  </div>
                </div>
              </div>
            )}
            {this.props.store.hideMainNav || config.collapseMainNav
              ? null
              : [
                  <nav className="main-nav" key="main-nav">
                    {this.navItems.map((item, i) => {
                      active = isActiveish(
                        this.props.location.pathname,
                        item.route,
                      )
                        ? "active"
                        : "";
                      return (
                        <NavLink
                          to={patientNavigationPath(
                            patient.asmpid,
                            patient.status,
                            item.route,
                          )}
                          className={active}
                          key={`navlink-${i}`}
                          onClick={this.navLinkClick}
                        >
                          {item.label}
                        </NavLink>
                      );
                    })}
                  </nav>,
                  <Switch key={`switch`}>
                    {this.navItems.map((item, i) =>
                      item.subnavItems ? (
                        <Route
                          path={patientNavigationPath(
                            patient.asmpid,
                            patient.status,
                            item.route,
                          )}
                          key={`route-${i}`}
                        >
                          <nav className="sub-nav">
                            {item.subnavItems.map((subnavItem, j) => (
                              <NavLink
                                to={patientNavigationPath(
                                  patient.asmpid,
                                  patient.status,
                                  subnavItem.route,
                                )}
                                key={j}
                                exact={subnavItem.exact !== false}
                              >
                                {subnavItem.label}
                              </NavLink>
                            ))}
                          </nav>
                        </Route>
                      ) : null,
                    )}
                  </Switch>,
                ]}
          </div>
        ) : null}
      </header>
    );
  }

  get isCreateStatement() {
    return this.props.location.pathname.match(/monitor\/create-statement/);
  }

  get displayName() {
    const username = this.props.store?.authStore.username;
    const userPreferences = this.props.store?.prefs?.userPreferences;
    if (
      config.pm.snippetApprovalOverride &&
      userPreferences?.server?.pm?.privileges?.includes?.("APPROVE_SNIPPET")
    ) {
      const roleValue = !userPreferences?.client?.pm?.preventSnippetAutoApproval
        ? "NURSE"
        : "MONITOR_TECH";
      if (roleValue) {
        const roleLabel = roleOptions.find((o) => o.value === roleValue)?.label;
        return `${username} - ${roleLabel}`;
      }
    }
    return username;
  }
  get patientSubheadInfo() {
    const patient = this.props.store?.patient;

    if (config.hidePHI) {
      return [
        patient.moduleSpecificData.find((d) => d.unit)?.unit,
        patient.moduleSpecificData.find((d) => d.location)?.location,
      ].filter((d) => d);
    } else {
      return [
        patient.mrn,
        patient.dateOfBirth,
        patient.moduleSpecificData.find((d) => d.unit)?.unit,
        patient.moduleSpecificData.find((d) => d.location)?.location,
        config.siteName,
      ].filter((d) => d);
    }
  }

  get currentNavItem() {
    return this.navItems[0];
  }
  get currentSubNavItem() {
    return get(this, "props.store.router.currentView.subnavItem");
  }
  get isPatientRoute() {
    return !!this.props.location.pathname.match(/^\/patient\//);
  }

  logout() {
    this.props.history.push("/logout");
  }

  toggleMenus() {
    this.props.store.menuOpen = !this.props.store.menuOpen;
  }

  toggleUserMenu() {
    this.props.store.userMenuOpen = !this.props.store.userMenuOpen;
    if (this.props.store.userMenuOpen) {
      requestAnimationFrame(() => {
        window.addEventListener("click", this.closeUserMenu, { once: true });
      });
    }
  }

  closeUserMenu() {
    this.props.store.userMenuOpen = false;
  }

  backToPatientList(e) {
    if (e) e.preventDefault();
    if (this.isCreateStatement) return;
    this.props.history.push("/patients");
  }

  share(e) {
    e && e.preventDefault();

    openShareLinkModal({
      route: this.shareRoute,
      patient: this.props.store.patient,
      path: this.props.location.pathname,
      messagingStore: this.props.store.messagingStore,
    });
  }

  get isSharable() {
    if (
      !get(
        this.props.store,
        "prefs.userPreferences.server.messaging.sharingEnabled",
      )
    )
      return false;
    return !!this.shareRoute;
  }

  get shareRoute() {
    return findRouteByWebRegExp({ path: this.props.location.pathname });
  }
}

const Header = withRouter(withStore(observer(HeaderWithoutRouter)));
export default Header;

export function dispatchEvent(eventName, element = window) {
  let event;
  if (typeof Event === "function") {
    event = new Event(eventName);
  } else {
    event = document.createEvent("Event");
    event.initEvent(eventName, true, true);
  }

  element.dispatchEvent(event);
}

export const navLinkClick = _.throttle(function navLinkClick(e) {
  if (window.location.href === e.target.href) {
    dispatchEvent("refreshWidget");
  }
});

export function isActiveish(location, path) {
  return location?.split("/").indexOf(path) !== -1;
}
